export default class extends HTMLElement {
  connectedCallback () {
    const slug = this.dataset.dateSlug
    if (slug) {
      try {
        if (sessionStorage.getItem('doccu_maintenance_banner_dismissed_' + slug)) {
          this.remove()
          return
        }
      } catch (err) {}
    }

    const dismissBtn = this.querySelector('[data-dismiss-banner]')
    if (dismissBtn) {
      dismissBtn.addEventListener('click', (e) => {
        e.preventDefault()
        if (slug) {
          try {
            sessionStorage.setItem('doccu_maintenance_banner_dismissed_' + slug, 'true')
          } catch (err) {}
        }
        this.remove()
      })
    }
  }
}
